import { Injectable } from '@angular/core';
import { ModalCommand } from '@models/easy-apply.model';

@Injectable({ providedIn: 'root' })
export class EasyApplyModalService {
  closeModal(): void {
    window.parent?.postMessage({ commandType: ModalCommand.OnClose }, '*');
  }
  sendReady(): void {
    window.parent?.postMessage({ commandType: ModalCommand.OnReady }, '*');
  }
}
